import NavComponents from '@/components/nav/Nav.vue'
const MyNav = {
  install (Vue) {
    Vue.component('my-nav-ui', NavComponents)
  }
}
export default MyNav



// WEBPACK FOOTER //
// ./src/components/nav/index.js